import logo_novapet_image from '@/assets/pets/logo novapet.png';

/**
 * React-level continuation of the boot splash in `index.html` — shown while a route
 * gate is checking session state (RequireAuth / RequireCustomerAuth silent refresh).
 * Same mint-ring-around-the-mark treatment so the handoff from the pre-React splash
 * is seamless. Deliberately theme-independent (fixed light brand background) — the
 * logo's navy ink only reads correctly on a light surface, and a splash is on screen
 * far too briefly to justify a dark-mode variant.
 */
export function SplashScreen(): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4"
      style={{
        background: 'radial-gradient(circle at 50% 40%, #eafcf6 0%, #f4faf8 45%, #ffffff 100%)',
      }}
    >
      <div className="relative flex items-center justify-center">
        <span className="novapet-live-pulse absolute h-32 w-32 rounded-full bg-[#9de6d7] opacity-30" />
        <img
          src={logo_novapet_image}
          alt="NovaPet"
          className="novapet-heartbeat relative z-10 h-24 w-auto object-contain"
        />
      </div>
      <span className="text-xs font-medium uppercase tracking-widest text-[#074069]/70">
        Cargando…
      </span>
    </div>
  );
}
